<template>
  <!-- 模块容器 -->
  <div class="relative w-full h-[47.24vw] py-[3.75vw]" id="about1id">
    <el-image
      class="absolute top-0 left-0 w-full h-full"
      :src="backgroundImage"
      lazy
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          企业简介
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          青少年航空科技创新教育践行者
        </div>
      </div>
    </div>

    <!-- 数据统计 -->
    <!-- 为数据统计容器添加 ref -->
    <div
      ref="statsContainer"
      class="stats-container relative w-full h-auto mx-auto flex justify-center gap-[4.58vw] font-harmony"
    >
      <div
        v-for="(item, index) in animatedStats"
        :key="index"
        class="flex flex-col items-center gap-[1.3vw]"
      >
        <!-- 数字部分：数字与加号分为两个 span -->
        <div
          class="flex flex-row items-center whitespace-nowrap text-[3.13vw] leading-[3.13vw] text-[#1A2233] text-center font-rubik font-normal"
        >
          <span>{{ item.current }}</span>
          <span class="plus" :class="{ 'fade-in': item.plusFaded }">+</span>
        </div>
        <!-- 文字部分：包裹在 label-wrapper 内 -->
        <div class="label-wrapper text-center" :style="{ width: '100%' }">
          <span
            class="text-[0.94vw] leading-[0.833vw] text-[#1A2233] text-center font-harmony font-normal"
            :class="{ 'label-fade': item.labelFaded }"
          >
            {{ item.label }}
          </span>
        </div>
      </div>
    </div>

    <!-- 文字信息容器 -->
    <div
      class="absolute text-left font-harmony"
      :style="{
        width: '30.06vw',
        height: '20vw',
        left: '19.27vw',
        top: '21.14vw',
      }"
    >
      <!-- 段落内容 -->
      <p
        class="text-[0.833vw] text-[#676B73] font-normal leading-[1.25vw] text-justify"
        style="text-justify: inter-ideograph"
      >
        西安蓝悦教育科技有限公司是面向
        <span class="text-[#F28334] font-bold">“小学、初中、高中”</span>
        阶段的青少年激发“创新思维”的新型教育机构。
      </p>

      <p
        class="text-[0.833vw] text-[#676B73] font-normal leading-[1.25vw] text-justify mt-[1.25vw]"
        style="text-justify: inter-ideograph"
      >
        公司依托陕西蓝悦无人机技术有限公司
        <span class="text-[#F28334] font-bold"
          >“研发设计、生产制造、飞行调试”</span
        >
        等工程实践，结合西北工业大学与陕西师范大学的基础教学经验为学生提供“航空理论知识、飞行器组装维修、飞控调试、飞机设计、国赛技术支持”等一体化学习实践并行的递进学习方法，以科技兴趣为导向的学习型思维模式。
      </p>

      <p
        class="text-[0.833vw] text-[#676B73] font-normal leading-[1.25vw] text-justify mt-[1.25vw]"
        style="text-justify: inter-ideograph"
      >
        公司秉承
        <span class="text-[#05358C] font-bold">“科学育人，启发开智”</span>
        的教育理念，立志为国家培养新时代航空人才。2019年至今公司受邀参与百余所学校航空科普教育宣传工作，受益学生近万名，得到校方与家长的充分认可，2023年公司获批中国航空学会“全国青少年无人机科学素质等级考试”指定考级点，2024年公司取得民航局颁发的“无人驾驶航空器运营合格证”。
      </p>

      <p
        class="text-[0.833vw] text-[#676B73] font-normal leading-[1.25vw] text-justify mt-[1.25vw]"
        style="text-justify: inter-ideograph"
      >
        2024年公司与陕西师范大学出版总社院士工作站、陕西师范大学附属小学开展多方合作共同探讨关于青少年科技人才的培养，联合开展
        <span class="text-[#05358C] font-bold">《航空探秘》</span>
        系列丛书编辑研发、
        <span class="text-[#05358C] font-bold">《院士科普基地》</span>
        建设等工作。
      </p>
    </div>

    <!-- 背景组合叠加图 -->
    <div class="absolute w-[15.86vw] h-[18.05vw] right-[19.27vw] top-[21.14vw]">
      <div
        class="w-full h-full bg-gradient-to-br from-[#2993fc] to-[#023dd3] shadow-[0px_12px_46px_0px_rgba(3,82,101,0.39)]"
      ></div>
      <div
        class="absolute w-[25.81vw] h-[18.05vw] right-[1.58vw] top-[1.83vw] shadow-[0px_12px_46px_0px_rgba(3,82,101,0.15)]"
      >
        <el-image
          class="w-full h-full object-cover"
          :src="require('@/assets/images/AboutUs/module2/sample4.png')"
          alt="背景图"
          lazy
          fit="cover"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "abouotus-module2",
  data() {
    return {
      backgroundImage: require("@/assets/images/Home/module2/sample1.png"),
      // 原始数据（target 为纯数字，便于计算动画）
      stats: [
        { target: 50, label: "合作院校" },
        { target: 100000, label: "服务学生" },
        { target: 60, label: "团队成员" },
        { target: 500, label: "荣获奖项" },
      ],
      animatedStats: [],
      animationTriggered: false,
    };
  },
  mounted() {
    // 初始化 animatedStats，current 用固定位数的字符串（初始全部为"0"）
    this.animatedStats = this.stats.map((item) => {
      const finalStr = String(item.target);
      let initial = "";
      for (let i = 0; i < finalStr.length; i++) {
        initial += "0";
      }
      return {
        target: item.target,
        current: initial,
        label: item.label,
        plusFaded: false,
        labelFaded: false,
      };
    });
    // 使用 IntersectionObserver 监听统计区域至少50%进入视口时触发动画
    // 调整观察器配置为完全进入视口触发
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animationTriggered) {
            // 添加可见类触发淡入
            entry.target.classList.add("visible");
            this.triggerAnimations();
            this.animationTriggered = true;
          }
        });
      },
      {
        threshold: 1, // 完全进入视口时触发
        rootMargin: "0px 0px -50px 0px", // 底部留50px缓冲
      }
    );
    observer.observe(this.$refs.statsContainer);
  },
  beforeDestroy() {
    // IntersectionObserver 无需手动移除
  },
  methods: {
    handleMouseDown() {
      this.$el.classList.add("active-state");
    },
    handleMouseUp() {
      this.$el.classList.remove("active-state");
      this.$el.blur();
    },
    // 启动所有动画
    triggerAnimations() {
      this.animatedStats.forEach((item, index) => {
        // 数字动画
        this.animateStat(index);
        // 同时启动加号与 label 的淡入动画
        this.$set(this.animatedStats[index], "plusFaded", true);
        this.$set(this.animatedStats[index], "labelFaded", true);
      });
    },
    // 数字动画：x秒内在固定位数基础上由快到慢随机变化，最终显示目标数字
    animateStat(index) {
      const startTime = performance.now();
      const duration = 1250;
      const target = this.animatedStats[index].target;
      const finalStr = String(target);
      const n = finalStr.length;

      // 初始化为0
      let currentValue = 0;
      this.$set(this.animatedStats[index], "current", "0".repeat(n));

      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // 计算当前值并格式化为固定位数
        currentValue = Math.floor(target * progress);
        const formatted = String(currentValue).padStart(n, "");

        this.$set(this.animatedStats[index], "current", formatted);

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          this.$set(this.animatedStats[index], "current", finalStr);
        }
      };
      requestAnimationFrame(update);
    },
  },
};
</script>

<style scoped>
/* 新增数字动画的初始显示过渡样式 */
.stats-container {
  opacity: 0;
  transition: opacity 0.5s ease;
}
.stats-container.visible {
  opacity: 1;
}

/* 按钮动画 */
/* 默认状态 */
.custom-el-button {
  border-color: #e4e7ed !important;
  color: #676b73 !important;
  transition: all 0.3s ease;
}
/* 悬停状态 */
.custom-el-button:hover {
  border-color: #05358c !important;
  color: #05358c !important;
}
/* 激活状态 */
.custom-el-button.active-state {
  border-color: #05358c !important;
  background-color: rgba(5, 53, 140, 0.1) !important;
}
/* 同步图标颜色 */
.custom-el-button:hover .el-icon-plus,
.custom-el-button.active-state .el-icon-plus {
  color: #05358c !important;
}

/* 加号淡入动画：初始 opacity 0，2s 后变为 1 */
.plus {
  display: inline-block;
  opacity: 0;
  transition: opacity 1.75s ease-in;
}
.plus.fade-in {
  opacity: 1;
}

/* label 淡入动画：采用 clip-path 实现从左向右逐步显示 */
.label-wrapper span {
  display: inline-block;
  clip-path: inset(0 100% 0 0);
  opacity: 0;
}
.label-wrapper span.label-fade {
  animation: revealText 1.75s forwards;
}
@keyframes revealText {
  from {
    clip-path: inset(0 100% 0 0);
    opacity: 0;
  }
  to {
    clip-path: inset(0 0 0 0);
    opacity: 1;
  }
}
/* 为避免 label 动画影响布局，外层容器保持固定宽度 */
.label-wrapper {
  overflow: hidden;
}
</style>